import { useEffect } from 'react';
import { AuthProvider } from '@/auth/AuthContext';
import GlobalUploadProgressPanel from '@/components/global/GlobalUploadProgressPanel';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { initializeAnalytics } from '@/lib/analytics';
import { usePageTracking } from '@/hooks/useAnalytics';
import { captureDeepLinkIntent } from '@/lib/deeplink';

const Provider = () => {
  useEffect(() => {
    initializeAnalytics();
    // Capture deep-link intent early before any routing decisions
    captureDeepLinkIntent();
  }, []);

  // Track page views and duration on route changes
  usePageTracking();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            <Outlet />
            <GlobalUploadProgressPanel />
            <Toaster richColors />
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
};

export default Provider;
